import { createContext, useContext } from 'react';
import type { HilEngine } from '@bizfirst/hil-core';
import type { IHilSubmitClient } from '@bizfirst/hil-core';

export interface HilContextValue {
  engine: HilEngine;
  submitClient: IHilSubmitClient;
  currentUserID: string | undefined;
  pushToEngine: (raw: unknown) => void;
}

export const HilContext = createContext<HilContextValue | null>(null);

export function useHilContext(): HilContextValue {
  const ctx = useContext(HilContext);
  if (!ctx) throw new Error('useHilContext must be used within HilProvider');
  return ctx;
}
